import Uploader from "@/components/Uploader.vue";
import Vue from "vue";
import LinkPost from "./post/LinkPost.vue";
import PageLoading from "@/components/discussion/post/PageLoading.vue";

export default {
    components: {
        Uploader,
        "post-link": LinkPost,
        "page-loading": PageLoading,
    },
    data: () => ({
        dialog: false,
        mode: "gallery",
        pageLoad: false,
        youtubeUrl: "",
        uploadPlaceholder: "Choose file to upload",
        text: "",
        info: {},
        imageFiles: [],
        list: [],
        imageUploadId: [],
        imageForCreatePost: [],
        linkData: null,
        otherFile: null,
        audioFile: null,
        editMode: false,
        editId: null,
        increase: 0,
    }),
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        validPost() {
            if (
                this.mode === "gallery" &&
                this.imageForCreatePost &&
                this.imageForCreatePost.length > 0
            ) {
                return true
            } else if (
                this.mode === "youtube" &&
                this.youtubeUrl &&
                this.youtubeUrl.length > 0
            ) {
                return true
            } else if (this.mode === "link") {
                return true
            } else if (this.mode === "other" || this.mode === "audio") {
                if (this.mode === "other" && !this.otherFile) {
                    // formData.append("otherFile", this.otherFile);
                    return true
                } else if (this.mode === "audio" && !this.audioFile) {
                    return true
                }
            } else if(this.text.length > 0){
                return true
            }
            return false
        }
    },
    mounted() {
        this.info = Vue.prototype.$userInfo;
        this.getPosts();
    },
    watch: {
        youtubeUrl(val) {
            this.handleSearch(val);
        }
    },
    methods: {
        setLinkData(data) {
            this.linkData = data;
        },
        deleteImage(url) {
            this.list = this.list.filter((l) => l.src !== url);
            this.imageForCreatePost = this.imageForCreatePost.filter(
                (l) => l.url !== url
            );
        },
        async uploadFile(file) {
            // this.showUploadPercent = true;
            let formData = new FormData();
            formData.append("fileupload", file);
            formData.append("title", file.name);
            await Vue.axios
                .post(`${this.$store.state.api}/post/uploadfile/image`, formData, {
                    ...this.$store.getters.requestHeaders,
                    onUploadProgress: function (progressEvent) {
                        // this.progressPercent = parseInt(
                        //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
                        // );
                    }.bind(this),
                })
                .then(
                    async function (response) {
                        await this.imageUploadId.push(response.data.result.url);
                        await this.imageForCreatePost.push(response.data.result);
                        // await this.oldFileId.push(response.data.result);
                        let imgUrl = response.data.result.url;
                        await this.list.push({ src: imgUrl });
                        // await this.oldFileUrl.push({ src: imgUrl });
                    }.bind(this)
                )
                .catch(function (e) { });
        },
        async onFileChange(files) {
            this.pageLoad = true;
            this.successUpload = false;
            let totalFiles;
            totalFiles = files.length;
            let resultImg;
            if (this.list.length + totalFiles > 20) {
                resultImg = 20 - this.list.length;
                this.warnnig(
                    `คุณสามารถอัพโหลดรูปภาพได้อีก ${resultImg} รูปเท่านั้น กรุณาเลือกรูปใหม่อีกครั้ง`,
                    "warning"
                );
                this.successUpload = true;
                this.imageFiles = [];
                return;
            }
            if (totalFiles === 0) {
                this.successUpload = true;
                return;
            } else {
                for (var i = 0; i < totalFiles; i++) {
                    await this.uploadFile(files[i]);
                }
                this.successUpload = true;
                this.imageFiles = [];
            }
            this.pageLoad = false;
        },
        onInputDialog(val) {
            this.dialog = val;
        },
        open(targetMode) {
            this.clear();
            this.$nextTick(() => {
                if (targetMode != null) {
                    this.mode = targetMode;
                }
                this.editMode = false;
                this.dialog = true;
            });
        },
        edit(data) {
            this.clear();
            this.$nextTick(() => {
                this.text = data.text
                this.editId = data.id
                this.editMode = true;
                this.dialog = true;
            });
        },
        close() {
            this.dialog = false;
            this.mode = "gallery"
            this.youtubeUrl = ""
            this.text = ""
            this.imageFiles = []
            this.list = []
            this.imageUploadId = []
            this.imageForCreatePost = []
            this.linkData = null
            this.otherFile = null
            this.audioFile = null
            this.editMode = false
            this.editId = null
            this.increase = 0
        },
        clear() {
            this.text = "";
            this.editId = null
            this.mode = "gallery";
        },
        openUploader(mode) {
            this.mode = mode;
            if (mode == "vdo") {
                this.uploadPlaceholder = "Choose video file to upload";
                this.accept = "video/*";
            } else {
                this.uploadPlaceholder = "Choose PDF file to upload";
                this.accept = "application/pdf";
            }
            setTimeout(() => {
                this.$refs.uploader.clear();
            }, 100);
        },
        getPosts() {
            // const url = this.$store.getters.urlQueryParameter(`${this.$store.state.api}-get`, {
            //   idcourse: this.courseId,
            //   limit: 100,
            //   page: 1,
            // });
            // Vue.axios
            //   .get(url, this.$store.getters.requestHeaders)
            //   .then((res) => {})
            //   .catch((err) => {})
            //   .finally(() => {});
        },
        clearForm() {
            this.text = "";
            this.imageForCreatePost = [];
            this.youtubeUrl = "";
            this.list = [];
            this.mode = "gallery";
        },
        createPost() {
            // this.$store.dispatch("createPost", {
            //   text: this.text,
            //   courseId: this.courseId,
            // });
            let formData;
            let dataCreatePost = {
                text: this.text,
                idcourse: this.courseId,
                canComment: true,
            };
            if (
                this.mode === "gallery" &&
                this.imageForCreatePost &&
                this.imageForCreatePost.length > 0
            ) {
                dataCreatePost.images = this.imageForCreatePost;
            } else if (
                this.mode === "youtube" &&
                this.youtubeUrl &&
                this.youtubeUrl.length > 0
            ) {
                dataCreatePost.urlyoutube = this.youtubeUrl;
            } else if (this.mode === "link") {
                dataCreatePost.link = this.linkData;
            } else if (this.mode === "other" || this.mode === "audio") {
                formData = new FormData();
                formData.append("text", dataCreatePost.text);
                formData.append("idcourse", dataCreatePost.idcourse);
                formData.append("canComment", dataCreatePost.canComment);
                dataCreatePost = undefined;
                if (this.mode === "other") {
                    formData.append("otherFile", this.otherFile);
                } else if (this.mode === "audio") {
                    formData.append("audio", this.audioFile);
                }
            }
            if (dataCreatePost) {
                this.sendNormal(dataCreatePost);
            } else if (formData) {
                this.sendNormal(formData);
            }
        },
        editPost() {
            let dataCreatePost = {
                text: this.text,
                idpost: this.editId
            };
            this.editNormal(dataCreatePost);
        },
        editNormal(data) {
            this.pageLoad = true;
            Vue.axios
                .put(
                    `${this.$store.state.api}/post/manage/update`,
                    data,
                    this.$store.getters.requestHeaders
                )
                .then((res) => {
                    this.pageLoad = false;
                    this.dialog = false;
                    this.$store.commit("updateDiscusstionPostList", {...res.data.result, editId: this.editId});
                    this.clearForm();
                })
                .catch((err) => {
                    this.errMsg = err.response.data.message;
                });
        },
        sendNormal(data) {
            this.pageLoad = true;
            Vue.axios
                .post(
                    `${this.$store.state.api}/post/manage/insert`,
                    data,
                    this.$store.getters.requestHeaders
                )
                .then((res) => {
                    this.pageLoad = false;
                    this.dialog = false;
                    this.$store.commit("updateDiscusstionPostList", res.data.result);
                    this.clearForm();
                })
                .catch((err) => {
                    this.errMsg = err.response.data.message;
                });
        },
        handleSearch(e) {
            this.youtubeUrl = e;
            this.increase++;
        }
    },
};
